export interface BrandingConfig {
  gameTitle: string;
  tagline: string;
  developerName: string;
  developerUrl: string;
  version: string;
  colors: {
    primaryGold: string;
    arcaneCyan: string;
    crimsonRed: string;
    stoneDark: string;
    stoneLight: string;
  };
}

export const BRANDING: BrandingConfig = {
  gameTitle: "Wizard Chess 3D",
  tagline: "An immersive fantasy chess experience",
  developerName: "ToolNPlay.com",
  developerUrl: "https://toolnplay.com",
  version: "1.0.0",
  colors: {
    primaryGold: "#d4af37",
    arcaneCyan: "#00d2ff",
    crimsonRed: "#ff3366",
    stoneDark: "#1a1c23",
    stoneLight: "#e2e8f0"
  }
};
